import { TranslateModule } from '@ngx-translate/core';
import { Locale, Maybe, Role } from '@iss/libs/graphql';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { NgIf } from '@angular/common';

import { CountryInputComponent } from '../country-input';

import {
  Control,
  FormFieldComponent,
  FormFieldErrorDirective,
  LabelDirective,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-country-field',
  templateUrl: './country-field.component.html',
  styleUrls: [ './country-field.component.scss' ],
  standalone: true,
  imports: [
    CountryInputComponent,
    FormFieldComponent,
    FormFieldErrorDirective,
    FormsModule,
    LabelDirective,
    NgIf,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class CountryFieldComponent {
  @Input() public countries: Maybe<readonly Locale[]>;
  @Input() public role: Maybe<Role>;
  @Input() public readonly: Maybe<boolean>;
  @Input() public showNecessity = true;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<Locale>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
